import LegalDocumentPage from '../components/LegalDocumentPage'
import { refundContent, REFUND_LAST_UPDATED } from '../content/refundContent'

const RefundPolicy = () => (
  <LegalDocumentPage
    contentByLanguage={refundContent}
    lastUpdated={REFUND_LAST_UPDATED}
  />
)

export default RefundPolicy
